import {
  CancelExperiencePlanDto,
  CancelExperiencePlanResponse,
  CancellationValues,
  ExperiencePlansResponse,
  StripePlanNames,
  StripePlanTypes,
  SubscribeToExperiencePlanDto,
  SubscribeToExperiencePlanResponse,
} from 'interfaces';

import {createAction} from '@reduxjs/toolkit';

/**
 * Fetch the currently active experience plan.
 */
export const getCurrentExperiencePlan = createAction(
  'GetCurrentExperiencePlan',
);
export const getCurrentExperiencePlanSuccess = createAction<
  ExperiencePlansResponse['data']
>('GetCurrentExperiencePlanSuccess');
export const getCurrentExperiencePlanFailure = createAction<string>(
  'GetCurrentExperiencePlanFailure',
);

/**
 * Subscribe to an experience plan.
 */
export const subscribeToExperiencePlan = createAction<
  SubscribeToExperiencePlanDto & {onSuccess?: () => void}
>('subscribeToExperiencePlan');
export const subscribeToExperiencePlanSuccess = createAction<
  SubscribeToExperiencePlanResponse['data']
>('subscribeToExperiencePlanSuccess');
export const subscribeToExperiencePlanFailure = createAction<string>(
  'subscribeToExperiencePlanFailure',
);

/**
 * Cancel an experience plan subscription.
 */
export const cancelExperiencePlan = createAction<
  CancelExperiencePlanDto & {onDone?: () => void}
>('CancelAddonSubscription');
export const cancelExperiencePlanSuccess = createAction<
  CancelExperiencePlanResponse['data']
>('CancelAddonSubscriptionSuccess');
export const cancelExperiencePlanFailure = createAction<string>(
  'CancelAddonSubscriptionFailure',
);

export const cancelSubscription =
  createAction<CancellationValues>('CancelSubscription');
export const cancelSubscriptionSuccess = createAction(
  'CancelSubscriptionSuccess',
);
export const cancelSubscriptionFailure = createAction(
  'CancelSubscriptionFailure',
);

export const annualPlanInterest = createAction<{
  paymentPlan: StripePlanTypes | StripePlanNames;
}>('annualPlanInterest');
export const annualPlanInterestSuccess = createAction(
  'annualPlanInterestSuccess',
);
export const annualPlanInterestFailure = createAction(
  'annualPlanInterestFailure',
);

export const pauseSubscription = createAction('PauseSubscription');
export const pauseSubscriptionSuccess = createAction(
  'PauseSubscriptionSuccess',
);
export const pauseSubscriptionFailure = createAction(
  'PauseSubscriptionFailure',
);

export const setManageSubscriptionState = createAction<{
  subscriptionState: 'upgrade' | 'pause' | 'cancel' | 'confirmCancel';
  data?: number | string | CancellationValues;
}>('setManageSubscriptionState');
export const resetManageSubscriptionState = createAction<{
  subscriptionState: 'none';
}>('ResetManageSubscriptionState');
